import axios from 'axios';
import accessLocalStorage from './accessLocalStorage';

const getConfig = async (tenantId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.get(
      `${ipRequest}api/call-inactivity/config/${tenantId}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { data: null };
    }
    throw error;
  }
};

const saveConfig = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.post(
      `${ipRequest}api/call-inactivity/config`,
      data,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateConfig = async (tenantId, data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.put(
      `${ipRequest}api/call-inactivity/config/${tenantId}`,
      data,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteConfig = async (tenantId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.delete(
      `${ipRequest}api/call-inactivity/config/${tenantId}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getAlertHistory = async (tenantId, filters = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const queryParams = new URLSearchParams();
    
    if (filters.alert_type) queryParams.append('alert_type', filters.alert_type);
    if (filters.resolved !== undefined) queryParams.append('resolved', filters.resolved);
    if (filters.start_date) queryParams.append('start_date', filters.start_date);
    if (filters.end_date) queryParams.append('end_date', filters.end_date);
    if (filters.limit) queryParams.append('limit', filters.limit);
    if (filters.offset) queryParams.append('offset', filters.offset);
    
    const queryString = queryParams.toString();
    const url = `${ipRequest}api/call-inactivity/alerts/${tenantId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await axios.get(url, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const forceCheck = async (tenantId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.post(
      `${ipRequest}api/call-inactivity/check/${tenantId}`,
      {},
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  getConfig,
  saveConfig,
  updateConfig,
  deleteConfig,
  getAlertHistory,
  forceCheck,
};

